import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import React from 'react'
import settings from 'settings'
import { withRouter } from 'react-router'
import io from 'socket.io-client'
import UIkit from 'uikit'

// Components
import ProxyBar from 'app/views/components/ProxyBar'
import Browser from 'app/views/components/Browser'
import CodeEditor from 'app/views/components/CodeEditor'
import CodeOutput from 'app/views/components/CodeOutput'
import LessonSidebar from 'app/views/components/LessonSidebar'

// Redux
import {
  sandboxSetPath,
  setIntercept,
  setStatus,
  setUrl,
  sandboxInit,
  sandboxReset,
  onRequest,
  onResponse,
  getPendingRequest,
} from 'app/state/modules/proxy'
import {
  replOnError,
  replOnViewError,
  replSetCode,
  replSetEngine,
  replSetEngines,
  replSetOutput,
  replSetDefaultEngine,
} from 'app/state/modules/repl'


const propTypes = {
  baseUrl: PropTypes.string.isRequired,
  ctaAboveLesson: PropTypes.bool,
  proxyStatus: PropTypes.oneOf([
    'loading',
    'reset',
    'init',
    'error',
    'listening',
    'disabled',
    'waiting',
  ]).isRequired,
  intercept: PropTypes.bool.isRequired,
  requests: PropTypes.array.isRequired,
  requestCount: PropTypes.number.isRequired,
  pendingRequest: PropTypes.object,
  onSandboxReset: PropTypes.func.isRequired,
  onSetStatus: PropTypes.func.isRequired,
  onSetIntercept: PropTypes.func.isRequired,
  onRequest: PropTypes.func.isRequired,
  onResponse: PropTypes.func.isRequired,
  onReplSetOutput: PropTypes.func.isRequired,
  onReplOnViewError: PropTypes.func.isRequired,
  onReplSetCode: PropTypes.func.isRequired,
  onReplSetEngines: PropTypes.func.isRequired,
}

const defaultProps = {
  ctaAboveLesson: false,
  pendingRequest: null,
}

class BrowserEditorArea extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      forceNew: false,
      pending_url: '',
    }

    this.socket = null
    this.isQuiz = this.props.match.path.includes('/quiz')
    this.handleSandboxReset = this.handleSandboxReset.bind(this)
    this.initializeSandbox = this.initializeSandbox.bind(this)
    this.handleOnInitAck = this.handleOnInitAck.bind(this)
    this.toggleIntercept = this.toggleIntercept.bind(this)
    this.handleOnRequest = this.handleOnRequest.bind(this)
    this.handleOnResume = this.handleOnResume.bind(this)
    this.handleOnResponse = this.handleOnResponse.bind(this)
    this.handleOnPopoutMode = this.handleOnPopoutMode.bind(this)
    if (this.props.onRef) {
      this.props.onRef(this)
    }
  }

  componentDidMount() {
    if (this.props.ecsTaskDefinition) {
      this.props.onSandboxReset()
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.ecsTaskDefinition
      && nextProps.ecsTaskDefinition !== this.props.ecsTaskDefinition
    ) {
      this.props.onSandboxReset()
    }

    if (
      nextProps.ecsTaskDefinition !== ''
      && nextProps.proxyStatus === 'reset'
      && nextProps.proxyStatus !== this.props.proxyStatus
    ) {
      this.props.onSandboxInit()
    } else if (
      nextProps.ecsTaskDefinition !== ''
      && nextProps.proxyStatus === 'init'
      && nextProps.proxyStatus !== this.props.proxyStatus
    ) {
      this.initializeSandbox()
    }
  }

  componentWillUnmount() {
    this.socket.disconnect()
  }

  handleSandboxReset(clickedByUser) {
    this.socket.disconnect()
    this.props.onSandboxReset(clickedByUser)
  }

  initializeSandbox() {
    this.socket = io.connect(settings.urls.control, {
      query: {
        token: `${this.props.idToken}`,
      },
    })

    this.socket.on('connect', () => {
      this.socket.emit('init', {
        ecs_task: this.props.ecsTaskDefinition,
        force_new: this.state.forceNew,
      })
      this.setState({ forceNew: true })
    })

    this.socket.on('init-ack', (msg) => {
      this.handleOnInitAck(msg)
    })

    this.socket.on('init-fail', (msg) => {
      console.error(msg)
      this.props.onSetStatus('error')
    })

    this.socket.on('request', msg => this.handleOnRequest(msg))

    this.socket.on('response', msg => this.handleOnResponse(msg))

    this.socket.on('eval-summary', (msg) => {
      this.props.onReplSetOutput(msg.output)
    })

    this.socket.on('message', (msg) => {
      if (msg.message === 'Intercept set to False') {
        if (this.state.pending_url !== '') {
          this.props.onSetUrl(this.state.pending_url)
          this.setState({ pending_url: '' })
        }
        if (this.props.proxyStatus !== 'init') {
          this.props.onSetStatus('disabled')
        }
      } else if (msg.message === 'Intercept set to True') {
        this.props.onSetStatus('listening')
      }
    })

    this.socket.on('pull-code-response', (msg) => {
      if ('data' in msg) {
        this.props.onReplSetCode(msg.data.data)
      }
    })
  }

  handleOnInitAck(msg) {
    this.toggleIntercept(false)
    this.props.onReplSetEngines(msg.engines)
    this.setState({ pending_url: msg.host })
  }

  toggleIntercept(enabled = !this.props.intercept) {
    this.socket.emit('set-intercept', {
      intercept: enabled,
      ecs_task: this.props.ecsTaskDefinition,
    })
    this.props.onSetIntercept(enabled)
  }

  handleOnRequest(request) {
    if (this.props.intercept) {
      UIkit.switcher('#tab-proxy').show(0)
      setTimeout(UIkit.offcanvas('#offcanvas-proxy').show, 300)
    }
    this.props.onRequest(request)
  }

  handleOnResume(modified) {
    const req = modified.request.split('\n')

    const location = req.shift().split(' ') // ['POST', '/signin', 'HTTP/1.1']
    const method = location[0]
    const path = location[1]
    const http_version = location[2]

    if (req.indexOf('') === 0) req.shift() // strip leading empty string
    // everything from last empty string to end is the body
    const body = req.splice(req.indexOf('') + 1, req.length - 1).join('\n')

    const headers = req.reduce((o, i) => {
      i = i.split(': ')
      const key = i[0]
      const val = i[1]
      if (key && val) {
        o[key] = val
      }
      return o
    }, {})

    this.socket.emit('resume', {
      ecs_task: this.props.ecsTaskDefinition,
      method,
      path,
      http_version,
      headers,
      body,
      // TODO: consider encoding body before sending back to proxy
      // body_encoded: window.btoa(window.encodeURI(body)),
    })
  }

  handleOnResponse(msg) {
    const {
      requestCount,
      pendingRequest,
      onResponse,
    } = this.props

    const item = pendingRequest || { body: null }
    item.response = msg

    // Enable intercept if we have 0 or 1 requests (because request 1 is the initial GET on the
    // proxy)
    if (requestCount < 2) {
      this.toggleIntercept(true)
    }

    if (this.props.intercept && msg.status_code !== 302) {
      UIkit.offcanvas('#offcanvas-proxy').hide()
    }

    onResponse(item)
  }

  handleOnPopoutMode(popoutMode) {
    this.setState({
      popoutMode,
      editorIsVisible: false,
    })

    if (popoutMode) {
      this.toggleIntercept(false)
      this.popoutWindow = window.open(this.props.baseUrl, 'popoutWindow', 'toolbar=1,status=0,width=800,height=1200')

      // check if the popup window is closed every 0.5 seconds. if it is closed, turn popup mode off
      const timer = setInterval(() => {
        if (this.popoutWindow.closed) {
          clearInterval(timer)
          this.handleOnPopoutMode(false)

          analytics.track('event-popout-closed', {
            lessonId: this.props.match.params.id,
            taskId: this.props.ecsTaskDefinition,
            engine: this.props.engine,
          })
        }
      }, 500)
    } else {
      this.popoutWindow.close()

      this.setState({ editorIsVisible: false })
    }
  }

  render() {
    return (
      <div>
        <div
          style={{
            width: 'calc(50% - 40px)',
            float: 'left',
          }}
        >
          {this.socket && this.props.engines.length > 0 ? (
            <CodeEditor
              isLight={this.isQuiz}
              engines={this.props.engines}
              codeSubmissions={[]}
              displayBar
              displaySubmitButton
              ecsTaskDefinition={this.props.ecsTaskDefinition}
              editorId="editor-sidebar"
              hasTest={this.props.hasTest}
              onSubmitClick={(code) => { this.props.onSubmitClick(code) }}
              onPatch={() => { }}
              onSetEngine={() => { }}
              onReplSetEngine={(engine) => { this.props.onReplSetEngine(engine) }}
              socket={this.socket}
              visible={this.state.editorIsVisible}
            />
          ) : null}
          <div className="uk-padding-small">
            <CodeOutput output={this.props.output} />
          </div>
        </div>
        <div
          style={{
            height: 'calc(100vh - 177px)',
            width: 'calc(50% - 40px)',
            float: 'left',
          }}
        >
          <div style={{ background: '#EEEEEE' }}>
            <ProxyBar
              resetCallback={() => this.browserRef.onTabClick(0)}
              intercept={this.props.intercept}
              onToggleIntercept={this.toggleIntercept}
              proxyStatus={this.props.proxyStatus}
              onSandboxReset={this.handleSandboxReset}
              ecsTaskDefinition={this.props.ecsTaskDefinition}
              handleOnPopout={(mode) => { this.handleOnPopoutMode(mode) }}
            />
          </div>
          <hr className="uk-margin-remove" />
          <div
            className="uk-margin-remove uk-padding-remove"
            style={{
              height: '100%',
            }}
          >
            <Browser
              onRef={(ref) => { this.browserRef = ref }}
              baseUrl={this.props.baseUrl}
              tabs={this.props.tabs}
              onSandboxSetPath={this.props.onSandboxSetPath}
            />
          </div>
        </div>
        <div
          className="uk-margin-remove uk-padding-remove uk-background-secondary uk-animation-slide-right uk-animation-fast"
          style={{
            width: 80,
            float: 'right',
            height: 'calc(100vh - 177px)',
          }}
        >
          <LessonSidebar
            isQuiz={this.isQuiz}
            codeSubmissions={[]}
            contentType="topic"
            ecsTaskDefinition={this.props.ecsTaskDefinition}
            engines={[]}
            hideCodeButton
            intercept={this.props.intercept}
            onClickResume={this.handleOnResume}
            onReplOnViewError={this.props.onReplOnViewError}
            pendingRequest={this.props.pendingRequest}
            requestCount={this.props.requestCount}
            requests={this.props.requests}
            socket={this.socket}
            visible
            onReplSetDefaultEngine={this.props.onReplSetDefaultEngine}
          />
        </div>
      </div>
    )
  }
}

BrowserEditorArea.propTypes = propTypes
BrowserEditorArea.defaultProps = defaultProps


const mapStateToProps = state => ({
  // Proxy
  baseUrl: state.proxy.url,
  proxyStatus: state.proxy.status,
  intercept: state.proxy.intercept,
  requests: state.proxy.requests,
  requestCount: Object.keys(state.proxy.requests).length,
  pendingRequest: getPendingRequest(state),

  // Auth
  unauthenticatedId: state.auth.user.unauthenticatedId,
  authenticationStatus: state.auth.authenticationStatus,
  idToken: state.auth.user.idToken,

  // Content
  challenges: state.content.challenges,
  lessons: state.content.lessons,

  // Repl
  replPatchSubmited: state.repl.patchSubmitted,
  replErrorViewed: state.repl.errorViewed,
  output: state.repl.output,
  engines: state.repl.engines,
})

const mapDispatchToProps = dispatch => ({
  // Proxy
  onSandboxSetPath: (path, search) => dispatch(sandboxSetPath(path, search)),
  onSetIntercept: intercept => dispatch(setIntercept(intercept)),
  onSetStatus: state => dispatch(setStatus(state)),
  onSetUrl: url => dispatch(setUrl(url)),
  onSandboxInit: () => dispatch(sandboxInit()),
  onSandboxReset: (clickedByUser) => dispatch(sandboxReset(clickedByUser)),
  onRequest: request => dispatch(onRequest(request)),
  onResponse: requests => dispatch(onResponse(requests)),

  // Repl
  onReplSetOutput: output => dispatch(replSetOutput(output)),
  onReplOnViewError: () => dispatch(replOnViewError()),
  onReplSetCode: code => dispatch(replSetCode(code)),
  onReplSetEngine: engine => dispatch(replSetEngine(engine)),
  onReplSetEngines: engines => dispatch(replSetEngines(engines)),
  onReplSetDefaultEngine: () => dispatch(replSetDefaultEngine()),
})


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BrowserEditorArea))
